/**
 * 这个组件抛给财务使用的 NCTable+total
 */

import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { tinperClsPrefix, getMultiLang, getSysFieldid, myBrowser, getGlobalStorage, PubSub } from '@platform/api';
import { Table } from '@platform/base';
import { getTotalData, getTotalScale, getFinalTotalData, getTotalColumns, addBlankCol } from './util'
import './index.less';
import { isFunction } from "../../utils";
import classnames from 'classnames';
// tinper提供的计算滚动条宽度的方法
const measureScrollbar = Table.measureScrollbar;

const totalTableHeight = 28;  // footer有2px边框

// 递归获取数据
function getColumnsItems(items, itemObj) {
    itemObj = itemObj || {};
    items?.forEach((element, i) => {
        itemObj[element.attrcode || element.dataIndex] = element;
        if (element.children) {
            getColumnsItems(element.children, itemObj);
        }
    });
    return itemObj;
}

export default function total(HighTable) {
    return class ModalTable extends Component {
        constructor(props) {
            super(props);
            this.state = { json: {} };
            this.browser = myBrowser();
            this.pubsubToken = null;
            // this.bodyColumn = props.columns
        }
        UNSAFE_componentWillMount() {
            let callback = json => {
                this.setState({ json });
            };
            getMultiLang({ moduleId: 'page_table', callback });
        }
        componentDidMount() {
            const { isTotal } = this.props;
            isTotal && this.addScrollEvent();
            isTotal && this.hidebodyScrollbar();
            window.addEventListener('resize', this.hidebodyScrollbar);
            let fontSize = getGlobalStorage('localStorage', 'nccFontSize');
            if (fontSize === 'large') {
                this.setState({ fontSize: 'large' });
            }
           
            this.pubsubToken = PubSub.subscribe('MODAL', ( mesg, { currentModal })=>{
                if(currentModal?.contains(this.table)){
                    this.hidebodyScrollbar()
                }
            });
        }
        // UNSAFE_componentWillReceiveProps(nextprops) {
        //     this.bodyColumn = nextprops.columns;
        // }
        componentDidUpdate() {
            const { isTotal } = this.props;
            isTotal && this.addScrollEvent();
            isTotal && this.hidebodyScrollbar();

        }
        componentWillUnmount() {
            const { isTotal } = this.props;
            window.removeEventListener('resize', this.hidebodyScrollbar);
            isTotal && this.removeScrollEvent();
            PubSub.unsubscribe(this.pubsubToken);
        }
        // 添加滚动事件
        addScrollEvent() {
            //每次重新绑定
            this.removeScrollEvent();
            let totalArea = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body`);
            let totalInnerArea = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body table`);
            totalArea && totalArea.addEventListener('scroll', this.addTotalAreaScrollEvent);
            totalInnerArea && totalInnerArea.addEventListener('scroll', this.addTotalInnerAreaScrollEvent);

            //最新优化---解决bee-table滚动条重置后，合计滚动条不联动，场景：横向滚动条拖动到最后，新增行，合计滚动条scrollLeft不变
            let bodyArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-body`);
            let headerArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-content .${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-header`);
            headerArea = bodyArea || headerArea;
            headerArea && headerArea.addEventListener('scroll', this.addHeaderAreaScrollEvent);

            // 目的是解决 火狐浏览器下 滚动条事件失效问题 NCCLOUD-163960
            if (myBrowser() == 'Firefox' && totalArea) {
                requestAnimationFrame(function () {
                    totalArea.style.overflowX = 'auto';
                    totalArea.style.marginBottom = '0px';
                });
                totalArea.style.marginBottom = '0px';
                totalArea.style.overflowX = 'hidden';
            }
        }

        addHeaderAreaScrollEvent = () => {
            let totalArea = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body`);
            let headerArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-content .${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-header`);
            //表头滚动条事件
            try {
                if (totalArea) { totalArea.scrollLeft = headerArea.scrollLeft; }
            } catch (e) {
                console.warn(e);
            }
        }

        addTotalAreaScrollEvent = () => {
            let totalArea = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body`);
            let bodyAreaTable = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-body table`);
            let bodyArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-body`);
            let headerArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-content .${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-header`);
            //合计行滚动条事件
            if (totalArea) {
                if (bodyArea) { bodyArea.scrollLeft = totalArea.scrollLeft; }
                if (bodyAreaTable) { bodyAreaTable.scrollLeft = totalArea.scrollLeft; }
                if (headerArea) { headerArea.scrollLeft = totalArea.scrollLeft; }
            }
        }
        addTotalInnerAreaScrollEvent = () => {
            let totalInnerArea = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body table`);
            let bodyAreaTable = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-body table`);
            let bodyArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-body table`);
            let headerArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-content .${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-header`);
            //合计行滚动条事件
            if (totalInnerArea) {
                if (bodyAreaTable) { bodyAreaTable.scrollLeft = totalInnerArea.scrollLeft; }
                if (bodyArea) { bodyArea.scrollLeft = totalInnerArea.scrollLeft; }
                if (headerArea) { headerArea.scrollLeft = totalInnerArea.scrollLeft; }
            }
        }
        // 去除滚动事件
        removeScrollEvent() {
            let totalArea = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body`);
            let totalInnerArea = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body table`);
            totalArea && totalArea.removeEventListener('scroll', this.addTotalAreaScrollEvent);
            totalInnerArea && totalInnerArea.removeEventListener('scroll', this.addTotalInnerAreaScrollEvent);

            let bodyArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-body`);
            let headerArea = this.table && this.table.querySelector(`.${tinperClsPrefix}-table-content .${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-header`);
            headerArea = bodyArea || headerArea;
            headerArea && headerArea.removeEventListener('scroll', this.addHeaderAreaScrollEvent);

        }
        onDropBorderHandler = () => {
            if (!this.total) {
                return
            }
            // let th = this.table.querySelectorAll('.nc-table:not(.total-row) >div.${tinperClsPrefix}-table-content >div.${tinperClsPrefix}-table-scroll >div:nth-child(1) .${tinperClsPrefix}-table-body table colgroup col');
            // let totalBody = this.total.querySelectorAll(`.${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-body colgroup col');
            // let length = th?.length || 0;
            // for (let i = 0, len = length; i < len; i++) {
            //     let newWidth = th[i] && th[i].style.width;
            //     if (totalBody[i]) {
            //         totalBody[i].style.width = newWidth;
            //         totalBody[i].style.minWidth = newWidth;
            //     }
            // }
            let footerBody = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body`)
            footerBody.style.overflowX = 'auto';
            this.hidebodyScrollbar();
            // this.bodyColumn = newColumn;
        };

        onDraggingBorder = () => {
            let th = this.table.querySelectorAll(`.nc-table:not(.total-row) >div.${tinperClsPrefix}-table-content >div.${tinperClsPrefix}-table-scroll >div:nth-child(1) .${tinperClsPrefix}-table-body table colgroup col`);
            let totalBody = this.total && this.total.querySelectorAll(`.${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-body colgroup col`);
            for (let i = 0, len = th.length; i < len; i++) {
                let newWidth = th[i] && th[i].style.width;
                if (totalBody[i]) {
                    totalBody[i].style.width = newWidth;
                }
                if (typeof newWidth === 'string') {
                    newWidth = Number(newWidth.match(/\d+/g)[0]);
                }
            }
            let footerBody = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body table`);
            if (footerBody) { footerBody.style.overflowX = 'auto' }
            this.hidebodyScrollbar();
            isFunction(this.props.onDraggingBorder) && (this.props.onDraggingBorder())
        };

        haveHorizontalScrollBar = () => {
            // let outbody = this.total && this.total.querySelector(`.${tinperClsPrefix}-table-body`);
            let outBody = this.table && this.table.querySelector(`.base-table-body-scroll-wrapper`);
            if (!outBody) { return false; }
            let overflow = outBody && window.getComputedStyle(outBody).getPropertyValue('overflow');
            let overflowX = outBody && window.getComputedStyle(outBody).getPropertyValue('overflow-X');
            let isOverFlow = outBody.scrollWidth - outBody.offsetWidth > 1 && (overflow == 'auto' || overflowX == 'scroll' || overflowX == 'auto');
            return isOverFlow;

            // if (outbody) {
            //     let innerbody = outbody.querySelector('table');
            //     if (innerbody) {
            //         // NCC-137931 电脑设置缩放150% 后出现1px误差
            //         return innerbody.offsetWidth + 8 - outbody.offsetWidth > 1
            //     } else {
            //         return false
            //     }

            // }
        }

        haveVerticalScrollBar = () => {
            let uTableScroll = this.total && this.total.parentNode.parentNode.parentNode;
            if (uTableScroll) {
                let offsetHeight = uTableScroll.querySelector(`.${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-body`)?.offsetHeight;
                let scrollHeight = uTableScroll.querySelector(`.${tinperClsPrefix}-table-scroll .${tinperClsPrefix}-table-body`)?.scrollHeight;
                return scrollHeight > offsetHeight
            }
            return false
        }

        //当有合计行时并且出现横向滚动条的时候，将合计行上移，盖住body部分的横向滚动条
        //当拖动模态框宽度的时候，需要重新计算合计行的style
        hidebodyScrollbar = () => {
            if (!this.total) { return }
            let tableFooter = this.total;
            // 空数据多了1px
            let isEmpty = !(this?.props?.data || []).length;
            if (this.haveHorizontalScrollBar()) {
                if (tableFooter) {
                    if (this.browser === 'Firefox') {
                        tableFooter.style.marginTop = '-10px';
                    } else if (this.browser === 'IE') {
                        tableFooter.style.marginTop = `-${28 + (isEmpty ? 1 : 0)}px`;
                    } else if (this.browser === 'Edge') {
                        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
                        if (userAgent.indexOf('Chrome') > -1) {
                            tableFooter.style.marginTop = `-${19 + (isEmpty ? 1 : 0)}px`;
                        } else {
                            tableFooter.style.marginTop = `-${28 + (isEmpty ? 1 : 0)}px`;
                        }
                    } else {
                        tableFooter.style.marginTop = `-${19 + (isEmpty ? 1 : 0)}px`;
                    }
                    tableFooter.className = tableFooter.className.replace(/total-table-has-scroll-y/gi, '');
                    if (this.haveVerticalScrollBar()) {
                        tableFooter.style.paddingRight = measureScrollbar() + 'px';
                        tableFooter.className += ' total-table-has-scroll-y';
                    } else {
                        tableFooter.style.paddingRight = '0px';
                    }
                }
                //用于合计行文字上下居中 NCCLOUD-191974
                let totalTd = this.total.querySelectorAll('td');
                if (totalTd && totalTd.length) {
                    for (let i = 0, len = totalTd.length; i < len; i++) {
                        if (this.browser === 'Firefox' || this.browser === 'IE' || this.browser === 'Edge') {
                            totalTd[i].style.paddingTop = '1px';
                        } else {
                            totalTd[i].style.paddingTop = '1px';
                        }
                    }
                }
            } else if (!this.haveHorizontalScrollBar()) {
                if (tableFooter) {
                    tableFooter.style.marginTop = '0px';
                    // 解决NCC-93556问题，在拖动滚动条时，overflowX值发生变化导致重绘
                    // let footerBody = tableFooter.querySelector(`.${tinperClsPrefix}-table-body table')
                    // if (footerBody) {
                    //     footerBody.style.overflowX = 'visible';
                    // }
                    // tableFooter.style.paddingRight = '0px';
                    tableFooter.className = tableFooter.className.replace(/total-table-has-scroll-y/gi, '');
                    if (this.haveVerticalScrollBar()) {
                        // tableFooter.style.paddingRight = measureScrollbar() + 'px';
                        tableFooter.className += ' total-table-has-scroll-y';
                    } else {
                        tableFooter.style.paddingRight = '0px';
                    }
                }
                let totalTd = this.total.querySelectorAll('td');
                if (totalTd && totalTd.length) {
                    for (let i = 0, len = totalTd.length; i < len; i++) {
                        totalTd[i].style.paddingTop = '0px';
                    }
                }

            }

            console.log("合计计算滚动条=样式更新===========")
        }

        handleFooter = columns => {
            let { data, totalConfig = {}, checkColConfig = {}, indexColConfig = {}, addBlankCol = true } = this.props;
            let finalColumns = [];
            let totalData = {};
            // transferTable insertTable
            if (totalConfig.totalData) {
                finalColumns = totalConfig.totalColumns
                totalData = totalConfig.totalData
                // 解决一下 空白列  及拖拽列宽
                let blankrowFlag = true;
                if (finalColumns.length) {
                    const columnsTempObj = getColumnsItems(columns);
                    finalColumns.forEach(element => {
                        if (element.attrcode == 'blankrow') {
                            blankrowFlag = false;
                        }
                        let item = columnsTempObj[element.attrcode || element.dataIndex];
                        if (item) {
                            element.width = item.width;
                        }
                    });
                    if (blankrowFlag && addBlankCol) {
                        let obj = {
                            title: <div className={'fake-line'} />,
                            key: 'blankrow',
                            dataIndex: 'blankrow',
                            attrcode: 'blankrow',
                            className: 'blankrow',
                            visible: true,
                            itemtype: 'customer',
                            width: "1px",
                            render: () => <div />,
                        };
                        finalColumns.push(obj);
                    }
                }
            } else {
                const { json } = this.state;
                //获得合计行的 items
                // finalColumns = getTotalColumns(this.columnAfterDrop || this.bodyColumn, { numberPd: totalConfig.numberPd });
                finalColumns = getTotalColumns(columns, { numberPd: totalConfig.numberPd, value: totalConfig.value }, checkColConfig, indexColConfig);
                // 获得 每一列的精度
                let totalScale = getTotalScale(finalColumns, data)
                //合计行的data
                totalData = getTotalData(finalColumns, data, totalConfig, totalScale || {});
                if (totalScale !== null) {
                    // 获取合计行进行精度处理后的数据
                    totalData = getFinalTotalData(totalData[0], totalScale);
                }
                //totalData = this.formNumber(totalData);
                //合计文字
                checkColConfig.showCheck ? totalData[0].checkbox = json['table002'] : totalData[0].numberindex = json['table002'];
            }

            if(finalColumns.length){
                console.log("total合计行表格render设置 columns")
            }

            return (
                <div fieldid={getSysFieldid('total-row')} className="total-container">
                    <Table
                        bodyClassName="total-body-scroll-wrapper"
                        minColumnWidth={80}
                        height={totalTableHeight}
                        ref={dom => {
                            this.total = ReactDOM.findDOMNode(dom);
                        }}
                        className={classnames('total-row',
                            { 'total-first-col-padding': this.state.fontSize }, //字体变大，合计两个字会被遮挡
                        )}
                        addBlankCol={false}
                        data={totalData}
                        columns={[...finalColumns]}
                        rowKey={'total-row'}
                        showHeader={false}
                        headerScroll={false}
                        scroll={{}}
                        bodyStyle={{ minHeight: totalTableHeight, overflowX: 'auto' }}
                    />
                </div>
            );
        };

        render() {
            const { isTotal, footerClassName = '', className = '' } = this.props
            if (isTotal) {
                return (<HighTable
                    {...this.props}
                    className={`${className}  table-use-total ${this.browser === 'Firefox' ? 'table-in-firefox' : ''}`}
                    footerClassName={`${footerClassName} total-wrapper-table-footer`}
                    handleFooter={(columns) => this.handleFooter(columns)}
                    setCellValue={params => {
                        // 暂时先去除
                        // this.forceUpdate()
                        // this.setState({});
                        isFunction(this.props.setCellValue) && (this.props.setCellValue(params))

                    }}
                    ref={dom => {
                        this.table = ReactDOM.findDOMNode(dom);
                    }}
                    // onDropAfter={newColumn => { this.columnAfterDrop = newColumn }}
                    onDropBorderHandler={() => { this.onDropBorderHandler() }}
                />)
            } else {
                return <HighTable {...this.props} />
            }
        }

    }
}